/** Short sine "click" on the audio output — countdown beeps, test tones and sync calibration. */
export function beep(ctx, when = ctx.currentTime, { freq = 1000, dur = 0.06, gain = 0.5, pan = 0 } = {}) {
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  const p = ctx.createStereoPanner();
  osc.frequency.value = freq;
  p.pan.value = pan;
  g.gain.setValueAtTime(0, when);
  g.gain.linearRampToValueAtTime(gain, when + 0.002);
  g.gain.exponentialRampToValueAtTime(0.0001, when + dur);
  osc.connect(g).connect(p).connect(ctx.destination);
  osc.start(when);
  osc.stop(when + dur + 0.02);
}

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
